import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useEffect } from 'react';
import { LoadingPage } from '../LoadingPage';
import { APIUrl, CommunityClient } from './CommunityClient';
import { AlertPresenter } from '../AlertBinder';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { AppPrincipal, isAnonymousViewer } from '../auth/AppPrincipal';
import { ICaremapAccess } from '../caremap/ICareMap';
import { UserAcceptInviteAlert } from './UserAcceptInviteAlert';
import { AnonymousAcceptInviteAlert } from './AnonymousAcceptInviteAlert';

export const InvitationAcceptancePage: React.FC<{ invite?: APIUrl; }> = ({ invite }) => {
    const client = useInstance(CommunityClient);
    const alert = useInstance(AlertPresenter);
    const history = useInstance(HistoryViewModel);
    const isAnonymous = isAnonymousViewer(useInstance(AppPrincipal));
    const userAcceptInviteAlert = useInstance(UserAcceptInviteAlert);
    const anonymousAcceptInviteAlert = useInstance(AnonymousAcceptInviteAlert);

    useEffect(() => {
        Promise.resolve().then(async () => {
            // defaults to co-owner
            // for backwards compatibility
            const access = (history.getCurrentSearchParams().get('access') || 'co-owner') as ICaremapAccess;
            const patient = history.getCurrentSearchParams().get('care-recipient') || '';

            client.validateInvite(invite);

            if (isAnonymous){
                await anonymousAcceptInviteAlert.show({ patient });
            } else {
                await userAcceptInviteAlert.show({ token: invite!, access, patient });
            }
        }).catch(e => {
            alert.showAndLogError(e);
            history.push('/');
        });
    }, [history, client, isAnonymous, anonymousAcceptInviteAlert, userAcceptInviteAlert, alert, invite]);

    return <LoadingPage showLogo />;
};
